export const colors = {
  pink: "#77316f",
  orange: "#f3754f",
  purple: "#491b54",
  blue : "#2d4877",
  text: {
    dark: '#333333',
    light: '#ffffff'
  },
  background: {
    light: '#f8f9fa',
    dark: '#212529'
  }
};


